
export interface UserRegister{
  email: string,
  password: string,
  firstname: string,
  lastname: string,
}

export interface UserLogin{
  email: string,
  password: string,
}


const UserClient = () => {
  return {
    async register(data: UserRegister){
      const response = await fetch('https://jung-self.herokuapp.com/user/', {
        method: 'POST',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      return await response.json();
    },

    async login(data: UserLogin){
      const response = await fetch('https://jung-self.herokuapp.com/user/login', {
        method: 'POST',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      return await response.json();
    },

    async getUser(token: string){
      const response =  await fetch('https://jung-self.herokuapp.com/user/me', {
        method: 'GET',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'x-auth': token
        },
      });
      return await response.json();
    },
  }
};

export default UserClient;
